<template>
  <section class="support-log">
    <div class="title-container">
      <h2>Support Log</h2>
      <v-radio-group
        v-model="type"
        :button="true"
        :list="typeOptions"
        @change="changeType"></v-radio-group>
    </div>
    <div class="log-container">
      <div
        v-for="(item, index) in logsData"
        :key="index"
        class="log-box">
        <div class="left">
          <span
            v-if="item.title === 'Address Updated'"
            class="icon-box edit-icon">
            <font-awesome-icon icon="pen" />
          </span>
          <span
            v-else-if="item.title === 'Remark'"
            class="icon-box remark-icon">
            <font-awesome-icon icon="sticky-note" />
          </span>
          <span
            v-else-if="item.title === 'Voice Call'"
            class="icon-box call-icon">
            <font-awesome-icon icon="phone" />
          </span>
          <span
            v-else-if="item.type==300"
            class="icon-box ticket-icon">
            <font-awesome-icon icon="user" />
          </span>
          <span
            v-else
            class="icon-box sms-icon">
            <font-awesome-icon icon="comment" />
          </span>
        </div>
        <div class="right">
          <div
            class="info-container"
            :class="{ 'white': item.type==300 }">
            <div class="flex-sb">
              <span class="title">{{ item.title }}</span>
              <span class="time">{{ item.created_at }}</span>
            </div>
            <div class="info">
              <span>
                {{ item.sender_type===1 ? 'CS': 'Customer' }}
                <span>{{ item.agent }}</span>
              </span>
              <span v-if="item.title === 'Voice Call'">
                Duration
                <span>{{ item.duration }}</span>
              </span>
            </div>
            <div
              v-if="false && item.title === 'Voice Call'"
              class="vidio-box">
              <v-audio src="http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4" />
            </div>
            <div
              v-if="item.message!=='null'&&item.message!=='undefined'"
              class="message-content">
              <span>{{typeof item.message === 'object'? item.message.content: item.message  }}</span>
            </div>
          </div>
          <file-container
            v-if="item.title == 'Remark' &&  item.message.remark_file"
            class="info-file"
            :marginBottom0="true"
            :fileData="item.message.remark_file" />
          <!--          <div-->
          <!--            v-if="item.type==300"-->
          <!--            class="file-container">-->
          <!--            <div class="file-box">-->
          <!--              <div class="file-info">-->
          <!--                <span>document123.pdf</span>-->
          <!--              </div>-->
          <!--              <div class="btn-box">-->
          <!--                <v-button-->
          <!--                  plain-->
          <!--                  type="primary"-->
          <!--                  size="small">Download</v-button>-->
          <!--              </div>-->
          <!--            </div> -->
          <!--          </div>-->
        </div>
      </div>
      <div
        v-if="logsData.length < 1"
        class="tips" >
        <span>No Data</span>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'SupportLog',
  props: {
    logsData: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      type: 0,
      typeOptions: [
        {
          name: 'All History',
          id: 0
        },
        {
          name: 'Remarks',
          id: 101
        },
        {
          name: 'Communications',
          id: 300
        },
        {
          name: 'Edits & Actions',
          id: 201
        }
      ]
    }
  },
  computed: {
    // handlerLogsData() {
    //   return this.logsData.map(item => {
    //     // item.message = item.message.replaceAll('\n', '<br />')
    //     item.message = String(item.message).replace(/\n/g, '<br />')
    //     return item
    //   })
    // }
  },
  methods: {
    changeType(type) {
      this.$emit('change', type)
    }
  }
}
</script>
<style lang="scss" scoped>
.support-log {
    .svg-inline--fa {
      color: white;
      font-size: 24px;
    }
    .title-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .tips {
        padding-top: 50px;
        font-size: 14px;
        text-align: center;
      }
      .log-container {
        margin-top: 12px;
        .log-box {
          display: flex;
          margin-bottom: 15px;
          &:last-child {
            .left::after {
              width: 0;
            }
          }
          .left {
            position: relative;
            &::after {
              position: absolute;
              z-index: 1;
              content: "";
              width: 5px;
              background: #dddfe7;
              top: 50px;
              bottom: -15px;
              left: 50%;
              transform: translateX(-50%);
            }
            span {
              z-index: 2;
              display: block;
              width: 50px;
              height: 50px;
              line-height: 50px;
              text-align: center;
              border-radius: 100%;
            }
            // .icon-box {
            //   text-align: center;
            // }
            .sms-icon {
              background: #68c23a;
            }
            .edit-icon {
              background: #e6a23d;
            }
            .remark-icon {
              background: #409eff;
            }
            .call-icon {
              background: #68c23a;
            }
            .ticket-icon {
              background: #91939a;
            }
          }
          .right {
            flex: 1;
            position: relative;
            margin-left: 15px;
            .info-container {
              padding: 10px 15px 0 15px;
              border: 1px solid #c5e7b1;
              border-radius: 4px;
              background-color: #f0faeb;
              &.white {
                border: 1px solid #DDDFE7;
                background-color: white;
              }
              .message-content {
                border-top: 1px solid #DDDFE7;
              }
            }
            .info-file {
              margin-top: 10px;
            }
            .info {
              padding-bottom: 5px;
              & > span {
                display: block;
                padding-bottom: 5px;
                font-size: 14px;
                font-weight: 500;
                color: #91939a;
                span {
                  display: inline-block;
                  padding-left: 5px;
                  font-weight: 400;
                }
              }
            }
            .file-container {
              margin-top: 10px;
            }
            .file-box {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 15px;
              padding: 0 15px;
              height: 65px;
              border: 1px solid #dddfe7;
              border-radius: 4px;
              background: #fcfcfc;
              &:last-child {
                margin-bottom: 5px;
              }
              .file-info {
                color: #616266;
                font-size: 16px;
              }
            }
            .blue {
              color: #1989fa;
            }
            .title {
              font-weight: bold;
              font-size: 16px;
            }
            .message-content {
              margin: 0 -15px;
              padding: 5px 15px;
              border-top: 1px solid #c5e7b1;
              white-space: pre-wrap;
            }
            .time {
              display: block;
              padding-left: 10px;
              // position: absolute;
              // top: 15px;
              // right: 15px;
              color: #91939a;
              font-size: 14px;
              font-weight: 500;
              white-space: nowrap;
            }
          }
        }
      }
}
</style>